@if(mobileQuery.matches) {
<div class="horizontal-sidebar py-2 px-2 border-b border-border">
  <div class="container">
    <div>
      <div class="horizontal-navbar flex flex-row items-center self-stretch">
        @for(item of navItems; track item) {
        <app-horizontal-nav-item [item]="item" class="parentBox {{ item.ddType }}" [ngClass]="{
                pactive: item.route == parentActive ? 'pactive' : ''
              }">
        </app-horizontal-nav-item>
        }
      </div>
    </div>
  </div>
</div>
}
